import { useQuery } from "@tanstack/react-query";

import { listRegions } from "../api/lookups";
import type { PennRegion } from "../types/auth-types/AuthUser";

export function useRegions() {
  return useQuery<PennRegion[]>({
    queryKey: ["lookups", "regions"],
    queryFn: listRegions,
    staleTime: 5 * 60 * 1000,
  });
}
